<template>
  <div>
    <WCCollapseCardGroup>
      <WCSearchFilterCategory
        v-for="category in filteredFacets"
        :key="category.key"
        :category="category"
        :categoryItemSearchInput="itemSearchInput"
        :categoryName="itemSearchCategory"
        @change="onChange"
        @clearCategoryFilter="onClearCategoryFilter"
        @categoryItemSearchInput="onCategoryItemSearch"
      />
    </WCCollapseCardGroup>
  </div>
</template>

<script>
import WCSearchFilterCategory from '@/components/WCSearchFilterCategory/WCSearchFilterCategory.vue';
import WCCollapseCardGroup from '../WCCollapseCardGroup/WCCollapseCardGroup.vue';
import FacetFilterMixin from '../../modules/filters/mixins/FacetFilterMixin';

export default {
  components: { WCCollapseCardGroup, WCSearchFilterCategory },
  emits: ['categoryFiltered', 'categoryItemSearchInput'],
  props: {
    itemSearchInput: {
      type: String,
    },
    itemSearchCategory: {
      type: String,
    },
  },
  mixins: [FacetFilterMixin],
  methods: {
    onClearCategoryFilter(category) {
      this.clearCategoryFilters(category);
    },
    onCategoryItemSearch(categoryItemSearchInput, categoryName) {
      this.$emit('categoryItemSearchInput', categoryItemSearchInput, categoryName);
    },
  },
  mounted() {
    this.$emit('categoryFiltered', this.filteredSelectedValues);
  },
};
</script>
<style scoped>
.wc-selected-header {
  line-height: 2.5;
}
</style>
